module.exports = __webpack_public_path__ + "static/img/ios_te.a73db41a.png";